import * as React from 'react';
import { st, classes } from './ColorPicker.base.st.css';
import { ColorPickerItem } from './ColorPickerItem/ColorPickerItem';
import { ErrorMessageWrapper } from '../internal/ErrorMessageWrapper';
import { colorPickerFieldsetLabelDataHook } from './dataHooks';
import uniqueId from '../../common/uniqueId';
class ColorPickerBase extends React.Component {
    constructor(props) {
        super(props);
        this._errorMessageId = uniqueId('error-message');
    }
    render() {
        const { onChange, children, className, name, errorMessage, label } = this.props;
        const stStates = { error: !!errorMessage };
        return (React.createElement(ErrorMessageWrapper, Object.assign({}, {
            visible: !!errorMessage,
            message: errorMessage,
            messageId: this._errorMessageId,
            className: st(classes.root, stStates, className),
            'data-hook': this.props['data-hook'],
        }),
            React.createElement("fieldset", { className: classes.container, "aria-label": this.props['aria-label'], "aria-labelledby": this.props['aria-labelledby'] },
                !!label && (React.createElement("legend", { "data-hook": colorPickerFieldsetLabelDataHook, className: classes.label }, label)),
                React.createElement("div", { className: classes.wrapper }, React.Children.map(children, (item, index) => {
                    if (!React.isValidElement(item)) {
                        return null;
                    }
                    return React.cloneElement(item, {
                        onChange: (event) => onChange(event, item.props.id),
                        key: index,
                        className: classes.item,
                        name,
                    });
                })))));
    }
}
ColorPickerBase.displayName = 'ColorPickerBase';
ColorPickerBase.Item = ColorPickerItem;
export { ColorPickerBase };
//# sourceMappingURL=ColorPicker.base.js.map